// extracted by mini-css-extract-plugin
module.exports = {"row":"OpticalClassification_row__3jIdW","left":"OpticalClassification_left__2hBB3","right":"OpticalClassification_right__r-J-E"};